<app-loading-spinner *ngIf="!classAssignmentReceived; else table"></app-loading-spinner>
<ng-template #table>
    <div class="assignment-header-background legend-header justify-content-between">
        <h1 class="assignment-header-title">Assignment Summary</h1>
        <div class="legend">
            <div class="legend-group">
                <i class="fas fa-circle upcoming"></i>
                <div class="legend-label upcoming">Upcoming</div>
            </div>
            <div class="legend-group">
                <i class="fas fa-star in-progress"></i>
                <div class="legend-label in-progress">In Progress</div>
            </div>
            <div class="legend-group">
                <i class="fas fa-square completed"></i>
                <div class="legend-label completed">Completed</div>
            </div>
        </div>
    </div>
    <div [class.scrollTable]="classAssignments && classAssignments.length > 8" #assignmentsTable>
        <table class="table">
            <thead>
                <th>Assignment Name</th>
                <th>Start</th>
                <th>End</th>
                <th># Activities</th>
                <th>Est. Time</th>
                <th></th>
            </thead>
            <tbody>
                <tr *ngIf="!classAssignments || classAssignments.length === 0" class="italic">
                    No assignments scheduled
                </tr>
                <tr *ngFor="let assignment of classAssignments; index as i" 
                [class]="nothing + (isPostTestAssignment(assignment) ? '' : ' hover')"
                    (click)="goToAssignmentDetails($event, assignment)">
                    <td>
                        <i [class]="getIconForState(assignmentStates[i])"></i>
                        <span *ngIf="editObj !== assignment"> {{ assignment.Name }}</span>
                        <input *ngIf="editObj === assignment" [(ngModel)]="assignment.Name">
                    </td>
                    <td>
                        <span *ngIf="editObj !== assignment">{{ longDateFormat(assignment.StartDate) }}</span>
                        <app-assignment-date-picker [(model)]="assignment.StartDate" [isStartDate]="true" 
                                [otherDate]="assignment.EndDate"
                                *ngIf="editObj === assignment" [placement]="i > 6 ? 'top' : 'bottom'">
                        </app-assignment-date-picker>
                    </td>
                    <td>
                        <span *ngIf="editObj !== assignment">{{ longDateFormat(assignment.EndDate) }}</span>
                        <app-assignment-date-picker [(model)]="assignment.EndDate" [isStartDate]="false" 
                                [otherDate]="assignment.StartDate"
                                *ngIf="editObj === assignment" [placement]="i > 6 ? 'top' : 'bottom'">
                        </app-assignment-date-picker>
                    </td>
                    <td>{{ assignment.ActivityCount || 0 }}</td>
                    <td>
                        <span>{{assignment.MinTime||0}}-{{assignment.MaxTime||0}} min</span>
                    </td>
                    <td class="actions">
                        <span *ngIf="assignmentStates[i] !== 'upcoming' && !editObj" (click)="showReport($event, assignment)">
                            <i class="fas fa-chart-bar pointer"></i>
                        </span>
                        <span *ngIf="assignmentStates[i] === 'upcoming' && !editObj" (click)="startEditObj($event, assignment)">
                            <i class="far fa-pencil-alt pointer"></i>
                        </span>
                        <span *ngIf="!isPostTestAssignment(assignment) && !editObj" (click)="deleteAssignment($event, assignment)">
                            <i class="far fa-trash-alt pointer"></i>
                        </span>
                        <span *ngIf="editObj === assignment" (click)="saveAssignment($event, assignment)">
                            <i class="far fa-save pointer"></i>
                        </span>
                        <span *ngIf="editObj === assignment" (click)="cancelEditAssignment($event, assignment)">
                            <i class="far fa-times pointer"></i>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <button class="btn btn-primary ml-2" (click)="addNewAssignment()">{{buttonText}}</button>
    <app-add-or-edit-assignment-modal 
        #newAssignment [organizationId]="organizationId" [students]="students"
        (dataRefresh)="assignmentCreated($event)">
    </app-add-or-edit-assignment-modal>
</ng-template>